require('./src/validate');
module.exports = 'ui.validate';



// WEBPACK FOOTER //
// ./app/vendor/angular-ui-validate/index.js